import React from 'react'
import { Container } from 'react-bootstrap'

const ShopPreOwnedRolex = () => {
  return (
    <Container className='mt-4'>
      <h2 className='font-weight-bold text-center mb-3'>Pre-Owned Rolex Collection</h2>
      <iframe title='Pre-Owned Rolex Collection' width="100%" height="1400px" src="https://marketing.timedelay.com/?r_id=649033494" className="framebg"></iframe>
    </Container>
  )
}

export default ShopPreOwnedRolex